<template>
  <div class="m-ctn-page">
    <ErrorPage
      :code="404"
      v-show="kill"
    ></ErrorPage>
    <div
      id="frameWrap"
      v-show="!kill"
      class="m-iframe-wrap"
    ></div>
  </div>
</template>

<script>
import axios from 'axios'
import ErrorPage from '@/components/ErrorPage'
export default {
  props: {
    srcInfo: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      isFirst: true,
      oldMenu: null,
      kill: false
    }
  },

  components: { ErrorPage },

  async mounted () {
    await this.judgeUrl()
    this.initIframe()
  },
  methods: {
    initIframe () {
      if (!this.kill && this.srcInfo) {
        let iframeWrap = document.getElementById('frameWrap')
        let newIframe = document.createElement('iframe')
        newIframe.style.width = '100%'
        newIframe.style.height = '100%'
        newIframe.setAttribute('id', `iseframe`)
        newIframe.setAttribute('src', this.srcInfo)
        newIframe.setAttribute('frameborder', 0)
        newIframe.setAttribute('allowfullscreen', true)
        iframeWrap.appendChild(newIframe)
      }
    },
    judgeUrl () {
      this.kill = false
      let reg = /http[s]{0,1}:\/\/([\w.]+\/?)\S*/
      if (this.srcInfo && !reg.test(this.srcInfo) && this.srcInfo.indexOf('/') !== 0) {
        this.srcInfo = `/${this.srcInfo}`
        // this.tryIframeLoad()
      } else if (!this.srcInfo && !this.isFirst) {
        this.kill = true
      }
    },
    async tryIframeLoad () {
      await axios.get(this.srcInfo).then(() => {
        this.kill = false
      }).catch(err => {
        if (err.message.indexOf('Network Error') >= 0) {
          this.kill = false
          this.$message.error(this.$t('common.errorServe'))
        } else if (err.message.indexOf('404') >= 0) {
          this.kill = true
        }
      })
    }
  },
  watch: {
    srcInfo () {
      this.judgeUrl()
      if (!this.kill) {
        let iframeWrap = document.getElementById('frameWrap')
        let iseframe = document.getElementById(`iseframe`)
        if (iseframe) {
          let _iseframe = iseframe.contentWindow
          iseframe.src = 'about:blank'
          try {
            _iseframe.document.write('')
            _iseframe.document.clear()
          } catch (e) {
            console.log(e)
          }
          iframeWrap.removeChild(iseframe)
          this.isFirst = false
          let newIframe = document.createElement('iframe')
          newIframe.style.width = '100%'
          newIframe.style.height = '100%'
          newIframe.setAttribute('id', `iseframe`)
          newIframe.setAttribute('src', this.srcInfo)
          newIframe.setAttribute('frameborder', 0)
          newIframe.setAttribute('allowfullscreen', true)
          iframeWrap.appendChild(newIframe)
        } else {
          this.initIframe()
        }
      }
    }
  }
}

</script>

<style lang="less" scoped>
.m-ctn-page {
  width: 100%;
  height: 100%;
  /deep/ .h-page-container {
    height: 100%;
  }
}
.m-iframe-wrap {
  width: 100%;
  height: 100%;
  overflow: hidden;
  iframe {
    width: 100%;
    height: 100%;
  }
}
</style>
